































































import {Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  入庫作成依頼型,
  入庫候補商品バリデータ一覧,
  入庫候補商品型,
  入庫マスタ選択区分型,
  コード入力検索条件バリデータ一覧,
  コード入力入庫候補検索条件型,
  コード入力入庫候補検索結果型,
  コード入力入庫候補商品型,
  確定対象である,
} from '@/type/stock/receive/item';
import {ValidationResult} from '@/type/validation/result';
import {入庫入力型} from '@/type/stock/receive/unfixed';
import api from '@/infrastructure/api/api';
import {processModule} from '@/store/process/process';
import {progress} from '@/script/progress';
import StockReceiveWholesaleSelector from '@/views/stock/receive/StockReceiveWholesaleSelector.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import {マスタ選択区分型} from '@/type/wholesale/types';

@Component({
  components: {
    StockReceiveWholesaleSelector,
    NormalDialog,
    ConfirmDialog,
    NormalButton,
    AmountField,
  },
})
export default class UnfixedItemSearch extends Vue {
  @Prop({default: false})
  private modal!: boolean;

  private コード入力入庫候補検索条件: コード入力入庫候補検索条件型 = this.検索条件初期値を取得();
  private コード入力入庫候補商品: コード入力入庫候補商品型[] = [];
  private 入庫候補商品一覧: コード入力入庫候補商品型[] = [];

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(コード入力検索条件バリデータ一覧);
  private 商品バリデーション結果: ValidationResult = new ValidationResult(入庫候補商品バリデータ一覧);

  private 選択中の行index: number|null = null;
  private グリッド件数: number | null = null;

  private グリッド最終行: number | null = null;

  private beforeOpened: boolean = false;
  private 重複した商品: boolean = false;

  @Watch('入庫候補商品一覧.JANコード', {deep: true})
    private 数量にフォーカス(): void {
      this.$nextTick(() => {
        this.グリッド最終行 = (this.件数を取得()) - 1;
        if (this.グリッド最終行 >= 0) {
          this.入力欄を指定().数量入力欄[this.グリッド最終行].$el.childNodes[0].focus();
          this.リスト選択時の処理(this.グリッド最終行);
          this.入庫候補商品一覧[this.グリッド最終行].選択 = true;
        }
      });
    }


  private beforeOpen() {
    const JANGTIN入力欄 = document.getElementById('JANGTIN入力欄');
    if (JANGTIN入力欄) {
      JANGTIN入力欄.focus();
    }
    this.beforeOpened = true;
  }

  private beforeUpdate() {
    this.検索条件バリデーション結果.validate(this.コード入力入庫候補検索条件);
    this.商品バリデーション結果.validateList(this.入庫候補商品一覧, 確定対象である);
  }

  private 検索条件エラー判定(項目名: string) {
    return {'input-error': this.検索条件バリデーション結果.hasError(項目名)};
  }

  private エラー判定(行番号: number, 項目名: string): boolean {
    if (!this.入庫候補商品一覧[行番号].選択) {
      return false;
    } else {
      return this.商品バリデーション結果.hasError(項目名, 行番号);
    }
  }

  private エラースタイル(行番号: number, 項目名: string) {
    return {'input-error': this.商品バリデーション結果.hasError(項目名, 行番号)};
  }

  private 閉じる() {
    this.beforeOpened = false;
    this.$modal.hide('入庫コード入力画面');
    this.$emit('finish-code-search');
  }

  private async 確定ハンドラ(): Promise<void> {
      if (this.商品バリデーション結果.hasErrors) {
        this.$emit('show-alert', this.商品バリデーション結果.getMessages(true));
        return;
      }

      const 選択済み商品 = this.入庫候補商品一覧.filter((商品: 入庫候補商品型) => 商品.選択);
      if (選択済み商品.length < 1) {
        this.$emit('show-alert', '確定対象が存在しません');
        return;
      }
      await progress(this.確定する);
  }

  private async 確定する(): Promise<void> {
      const 選択済み商品 = this.入庫候補商品一覧.filter((商品: 入庫候補商品型) => 商品.選択);
      const 入庫作成依頼: 入庫作成依頼型 = {入庫登録商品選択一覧: 選択済み商品};
      await api.商品から入庫を生成する(入庫作成依頼)
        .then((response: 入庫入力型[]) => {
          const 商品から作成した入力一覧: 入庫入力型[] = response;
          this.selectItem(商品から作成した入力一覧);
          this.beforeOpened = false;
          this.$modal.hide('入庫コード入力画面');
          this.$emit('finish-code-search');
          this.入庫候補商品一覧 = [];
        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
  }

  @Emit() private selectItem(入庫入力一覧: 入庫入力型[]) {
      return;
  }

  private created() {
      this.入庫候補商品一覧 = [];
  }

  private async 検索ハンドラ(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.$emit('show-alert', this.検索条件バリデーション結果.getMessages());
      return;
    }

    await progress(this.検索する);
  }

  private async 確認後の検索するハンドラ() {
    this.ダイアログを閉じる('商品追加選択中確認ダイアログ');
    await progress(this.検索する);
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private async 検索する(): Promise<void> {
    if (this.コード入力入庫候補検索条件.JANコードまたは販売GTINコード.length < 1) {
      this.$emit('show-alert', 'JAN/販売GTINコードは入力が必須です');
      return;
    }

    await api.コード入力入庫候補商品を検索する(this.コード入力入庫候補検索条件)
      .then((response: コード入力入庫候補検索結果型) => {
        this.コード入力入庫候補商品 = response.入庫商品一覧;
        this.選択中の行index = null;
        if (this.コード入力入庫候補商品.length === 0) {
          this.$emit('show-alert', '検索結果が0件です。');
          return;
        }
        if (response.アラートメッセージ) {
          this.$emit('show-alert', response.アラートメッセージ);
        }
      })
      .catch((error: any) => {
        this.$emit('show-alert', error.data.message);
      });

    this.重複した商品 = this.重複商品のチェック();

    this.入庫候補商品一覧 = this.入庫候補商品一覧.concat(this.コード入力入庫候補商品);
  }

  private マスタ選択区分一覧を取得(): 入庫マスタ選択区分型[] {
    return [
      入庫マスタ選択区分型.採用品,
      入庫マスタ選択区分型.医薬品,
      入庫マスタ選択区分型.その他品,
    ];
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.入庫候補商品一覧 = [];
      this.コード入力入庫候補検索条件 = this.検索条件初期値を取得();
      this.選択中の行index = null;
      this.重複した商品 = false;
      this.$modal.show('入庫コード入力画面');
    }
  }

  private 検索条件初期値を取得(): コード入力入庫候補検索条件型 {
    return {
      JANコードまたは販売GTINコード: '',
    };
  }

  private 採用区分をマスタ選択区分に変換する(採用区分: string): マスタ選択区分型 {
    return (採用区分 === '採用') ? マスタ選択区分型.採用品 : マスタ選択区分型.指定なし;
  }

  private JANGTINにフォーカス(keyCode: number, repeat: boolean): void {
    if (keyCode !== 13) return;
    if (repeat === true) return;
    this.コード入力入庫候補検索条件 = this.検索条件初期値を取得();
    this.入力欄を指定().JANGTIN入力欄.focus();
  }

  private 入力欄を指定(): any {
    return this.$refs;
  }

  private 件数を取得() {
    return this.入庫候補商品一覧.length;
  }

  private 重複商品のチェック(): boolean {
    for (const index in this.入庫候補商品一覧) {
      if (this.入庫候補商品一覧[index].JANコード === this.コード入力入庫候補商品[0].JANコード) {
        return true;
      }
    }
    return false;
  }

}
